import axios from "axios";

const API = process.env.VUE_APP_API_URL + "/email_confirmations";

export default {
  confirm(token) {
    return axios.get(API + "/" + token)
  }
};